module.exports = __webpack_public_path__ + "img/icon-state-store.c4c7284b.svg";